import Repository from './Repository';

export default class UserRepository extends Repository {
    protected basePath = 'users';

    protected messages = {
        destroy : this.__('Felhasználó sikeresen törölve.'),
        store : this.__('Felhasználó sikeresen létrehozva.'),
        update : this.__('Felhasználó sikeresen frissítve.'),
    }

    protected redirects = {
        store: { name : 'users' }
    }

    public import(data: object): Promise {
        console.error('Import method does not exist on UserRepository.');
    }
}